import React, {createContext, useContext, useEffect, useState} from "react";
import { FilterOption } from "../types/filterTypes";
import {SearchOptions} from "../types/mamTypes";


// Definizione del tipo per il contesto
interface VideoContentTagsContextOptionsType {
    videoContentTagsOptions: string[];
    addVideoContentTagsOptions: (videoContentTagsOptions: string[]) => void;
}

const maxVideoContentTagsOptions = 3;

// Creazione del contesto
const VideoContentTagsContextOptions = createContext<VideoContentTagsContextOptionsType | undefined>(undefined);
// Provider del contesto
export const VideoContentTagsOptionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [videoContentTagsOptions, setVideoContentTagsOptions] = useState<string[]>([]);

    function addVideoContentTagsOptions(newVideoContentTags: string[]){
        const tempVideoContentTags = [...videoContentTagsOptions]
        const mergedTags = [...newVideoContentTags.reverse(), ...tempVideoContentTags];
        const uniqueTags = Array.from(new Set(mergedTags));
        if (uniqueTags.length > maxVideoContentTagsOptions){
            uniqueTags.splice(maxVideoContentTagsOptions, uniqueTags.length - maxVideoContentTagsOptions)
        }
        setVideoContentTagsOptions(uniqueTags);
        localStorage.setItem("videoContentTagsOptions", JSON.stringify(uniqueTags));
    }

    useEffect(() => {
        const tempVideoContentTagsString = localStorage.getItem("videoContentTagsOptions")
        tempVideoContentTagsString ? setVideoContentTagsOptions(JSON.parse(tempVideoContentTagsString)) : setVideoContentTagsOptions([])
    }, []);

    return (
        <VideoContentTagsContextOptions.Provider value={{videoContentTagsOptions, addVideoContentTagsOptions}}>
            {children}
        </VideoContentTagsContextOptions.Provider>
    );
};

// Custom Hook per usare il contesto
export const useVideoContentTagsOptions = () => {
    const context = useContext(VideoContentTagsContextOptions);
    if (!context) {
        throw new Error("useVideoContentFilters must be used within VideoContentTagsProvider");
    }
    return context;
};
